import * as req from 'api/actions';
import * as c from './constant';

export const getRangeCalculationList = (id, payload, callback) =>
  req.list(
    c.GET_RANGE_CALCULATION_LIST,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_ranges`,
    payload,
    callback
  );

export const rangeCalculationInfo = (id, payload, callback) =>
  req.item(
    c.RANGE_CALCULATION_INFO,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_ranges`,
    payload,
    callback
  );

export const createRangeFees = (id, payload, callback) =>
  req.create(
    c.CREATE_RANGE_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_ranges`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeRangeFees = (id, newOtherFeesId, payload, callback) =>
  req.remove(
    c.REMOVE_RANGE_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${newOtherFeesId}/calculation_ranges/${id}`,
    payload,
    callback
  );

export const updateRangeFees = (id, newOtherFeesId, payload, callback) =>
  req.update(
    c.UPDATE_RANGE_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${newOtherFeesId}/calculation_ranges/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getNewOtherFeesList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_NEW_OTHER_FEES,
    '/api/v1/bpls/administrator/tax_revenue/other_fees',
    payload,
    callback
  );

export const getSingleNewOtherFees = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_NEW_OTHER_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}`,
    payload,
    callback
  );